<div class="flex flex-row items-center gap-2">
  <mat-icon class="icon-sm shrink-0 opacity-50">numbers</mat-icon>
  <div class="flex grow">
    @if (campaign().maximumEntriesPerRun; as maximumEntriesPerRun) {
      <span>
        Each campaign run can enrol up to
        <span class="font-bold">
          {{ maximumEntriesPerRun }} {{ entryScope() }}.
        </span>
        Any additional {{ entryScope() }} will be carried over to the next run.
      </span>
    } @else {
      <span>
        There's no limit on how many {{ entryScope() }} can be enrolled in each
        run.
      </span>
    }
  </div>
</div>

@if (campaign().recurrencePattern; as recurrencePattern) {
  <div class="flex flex-row items-center gap-2">
    <mat-icon class="icon-sm shrink-0 opacity-50">repeat</mat-icon>
    <div class="flex grow">
      <span>
        The campaign will run <strong>automatically</strong> to enrol
        {{ entryScope() }}
        <pr-recurrence-summary
          [recurrence]="recurrencePattern"
          [runTime]="campaign().recurrenceRunTime"
        />.
      </span>
    </div>
  </div>
} @else {
  <div class="flex flex-row gap-2">
    <mat-icon class="icon-sm shrink-0 opacity-50">build</mat-icon>
    <div class="flex grow">
      <span>
        Each campaign run must be started
        <span class="font-bold">manually.</span>
      </span>
    </div>
  </div>
}
